import { render, staticRenderFns } from "./veStuMoralProgramMy.vue?vue&type=template&id=526a8bf8&scoped=true"
import script from "./veStuMoralProgramMy.vue?vue&type=script&lang=js"
export * from "./veStuMoralProgramMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a8bf8",
  null
  
)

export default component.exports